/* Raw execution result returned by a `PhpRuntime`. This is the runtime-level
 * contract (bytes/numbers from the engine); the results UI transforms it into
 * the semantic `RunDisplay` (see features/results/result-types.ts). */

export interface RunResult {
  stdout: string;
  /** decoded standard error (warnings, notices, fatals). */
  stderr: string;
  /** process exit code (0 = success). */
  exitCode: number;
  /** wall-clock execution time in ms (worker-measured, excludes engine boot). */
  timeMs: number;
  /** peak memory in bytes (PHP `memory_get_peak_usage(true)`). */
  memBytes: number;
}

/** Options for a single run. */
export interface RunOptions {
  stdin?: string;
  /** CLI argument string (space-split into argv). */
  args?: string;
  signal?: AbortSignal;
  /** wall-clock cap in ms; runtime is terminated + re-initialised on hit. */
  timeoutMs?: number;
}

export class RunAbortError extends Error {
  constructor(
    message: string,
    /** 'cancel' = user/abort signal, 'timeout' = wall-clock cap hit. */
    readonly kind: 'cancel' | 'timeout',
  ) {
    super(message);
    this.name = 'RunAbortError';
  }
}
